<div class="filter-container">
  <div class="filter-window">
    <div class="row">
      <div class="form-container col-12">
        <form [formGroup]="stockCountLocationForm">
          <div class="form_inner">
            <div class="form-group row">
              <eps-select
                [busy]="shipTosLoading"
                [options]="shipTos"
                [disabled]="isSaving || (shipTos && shipTos.length <= 1)"
                autoSelect
                formControlName="shipToId"
                label="BLANK_RECEIPT.SHIP_TOS"
                ></eps-select>
            </div>

            <div class="end-xs">
              <eps-button
                type="primary"
                [disabled]="stockCountLocationForm.invalid"
                [busy]="isSaving"
                (buttonClick)="loadStockCounts()"
                [label]="(isPrint ? 'STOCK_COUNT.BUTTONS.PRINT' : 'STOCK_COUNT.BUTTONS.CREATE_STOCKCOUNT')"
                buttonIcon="plus-square"></eps-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

